<template>
  <lazy-div :load="doInit">
    <v-card>
    <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
          <v-card-title>
            <v-flex xs4>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-layout row>
                <v-spacer></v-spacer>
                <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                  <v-btn color="secondary" class="white--text" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                  <v-card>
                    <v-card-text>
                      <template v-if="columns.length > 0">
                        <v-checkbox
                          v-for="column in columns"
                          :key="column.value"
                          :label="column.text"
                          :value="column.value"
                          v-model="selectedColumns"
                        ></v-checkbox>
                      </template>
                      <template v-else> No column found </template>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-layout>
            </v-flex>
          </v-card-title>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12 class="mt-2">
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :options.sync="pagination"
            item-key="index"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >

          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.effDate }}</td>
              <td>{{ row.item.polType }}</td>
              <td>{{ row.item.commPct }}</td>
              <td>{{ row.item.protComm }}</td>
              <td>{{ row.item.commGn }}</td>
              <td>{{ row.item.discPct }}</td>
              <td>{{ row.item.protDisc }}</td>
              <td>{{ row.item.void_ }}</td>
              <td class="table-action-header">
                <table-action
                    :rowData="row"
                    review
                    @review="doReview"
                    query
                    @query="doQuery"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
              </td>
            </tr>
          </template>
          </v-data-table>
          <v-flex xs4>
            <v-checkbox :label="labels.voidTransaction" v-model="voidTransaction" @change="doInit()"></v-checkbox>
          </v-flex>
          <v-flex xs4>
            <v-btn color="primary" dark class="mb-2" @click="doNew">New Commission<v-icon>mdi-plus</v-icon></v-btn>
          </v-flex>
        </v-flex>
          <!-- <v-checkbox :label="labels.voidTransaction" v-model="voidTransaction" @change="doInit()"></v-checkbox> -->
          <confirm v-model="promptRemove" @ok="doRemove()"> Are you sure that you want to delete the selected Commission? </confirm>
      </v-flex>
    </v-layout>
  </v-container>
</v-card>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
// import clone from 'clone'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
// import { expandURI, filterQuery } from '@/utils/ajax'
import { listMixin } from '@/components/reusable/listMixins'
export default {
  data() {
    return {
      headers: [
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Rate', value: 'commPct' },
        { text: 'Gross/Net', value: 'commGn' },
        { text: 'Protected', value: 'protComm' },
        { text: 'Discount', value: 'discPct' },
        { text: 'Disc Protected', value: 'protDisc' },
        { text: 'Void', value: 'void_' }
      ],
      columns: [
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Policy Type', value: 'polType' },
        { text: 'Rate', value: 'commPct' },
        { text: 'Gross/Net', value: 'commGn' },
        { text: 'Protected', value: 'protComm' },
        { text: 'Discount', value: 'discPct' },
        { text: 'Disc Protected', value: 'protDisc' },
        { text: 'Void', value: 'void_' }
      ],
      selectedColumns: ['effDate', 'polType', 'commPct', 'commGn'],
      pagination: {
        page: 1,
        sortBy: ['effDate']
      },
      labels: {
        voidTransaction: 'Include void transactions'
      },
      // deleteCommission: '',
      promptRemove: false,
      voidTransaction: false,
      menu: []
    }
  },
  watch: {
    fetchCommission: function (value) {
      if (value !== false) {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
    // schemeMenu() {
    //   return this.$store.state.parameters.scheme.schemeMenu
    // }
  },
  methods: {
    async doInit() {
      if (!this.voidTransaction) {
        this.loading = true
        const apiURI = this.$store.state.adminInter.intermediary.menu.commissionList
        if (apiURI) {
          try {
            const expand = {
              inter: this.inter
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((commission) => {
                const convertCommission = {
                  effDateTime: commission.effDate,
                  effDate: this.formatDate(commission.effDate),
                  polType: commission.polType,
                  commPct: commission.commPct,
                  protComm: this.formatBoolean(commission.protComm),
                  commGn: commission.commGn,
                  discPct: commission.discPct,
                  protDisc: this.formatBoolean(commission.protDisc),
                  void_: this.formatBoolean(commission.void_)
                }
                this.items.push(convertCommission)
              })
              this.loading = false
            } else {
              this.loading = false
              this.items = []
            }
          } catch (error) {
            const { data } = error
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          }
        } else {
          this.loading = false
        }
      } else {
        this.loading = true
        const apiURI = this.$store.state.adminInter.intermediary.menu.commissionList2
        if (apiURI) {
          try {
            const expand = {
              inter: this.inter
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((commission) => {
                const convertCommission = {
                  effDateTime: commission.effDate,
                  effDate: this.formatDate(commission.effDate),
                  polType: commission.polType,
                  commPct: commission.commPct,
                  protComm: this.formatBoolean(commission.protComm),
                  commGn: commission.commGn,
                  discPct: commission.discPct,
                  protDisc: this.formatBoolean(commission.protDisc),
                  void_: this.formatBoolean(commission.void_)
                }
                this.items.push(convertCommission)
              })
              this.loading = false
            } else {
              this.loading = false
              this.items = []
            }
          } catch (error) {
            const { data } = error
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          }
        } else {
          this.loading = false
        }
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doQuery(data) {
      this.$emit('doQuery', data.item)
    },
    doNew() {
      if (this.interGroupCode === '10' || this.interGroupCode === '11' || this.interGroupCode === '13') {
        this.$emit('doNew')
      } else {
        this.$toast.error('Commission not allowed for this intermediary')
        this.$router.push({ name: 'intermediaries' })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCommission = data
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.updateCommissionVoid
      if (apiURI) {
        this.loading = true
        const formatForm = {
          inter: this.inter,
          effDate: this.selectedCommission.effDateTime,
          polType: this.selectedCommission.polType,
          void_: true
        }
        try {
          const result = await this.$http.put(apiURI, formatForm)
          this.notify(result.data)
          this.doInit()
          // this.doInit()
          // Reinit
          // const formatForm2 = {
          //   inter: this.inter,
          //   effDateTime: this.selectedCommission.effDateTime,
          //   polType: this.selectedCommission.polType
          // }
          // this.$emit('doReview', formatForm2)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. - Delete Scheme')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  props: {
    fetchCommission: {
      type: Boolean,
      default: false
    },
    inter: {
      type: String,
      default: ''
    },
    interGroupCode: {
      type: String,
      default: ''
    }
  },
  mixins: [listMixin, MessageMixin]
}
</script>

<style>
</style>
